module.exports = __webpack_public_path__ + "img/whatsapp.188a2786.png";